import { Controller } from "@hotwired/stimulus"

// The item form's image choice. The picker grid is a turbo-frame that is replaced
// on every page/filter change, so the choice lives in a hidden input outside it;
// every card that arrives is highlighted against that input.
export default class extends Controller {
  static targets = ["input", "label", "card"]

  choose({ params: { id, label } }) {
    this.inputTarget.value = String(id)
    this.labelTarget.textContent = label
    this.#highlight()
  }

  cardTargetConnected() {
    this.#highlight()
  }

  #highlight() {
    this.cardTargets.forEach((card) => {
      const chosen = String(card.dataset.imagePickerIdParam) === this.inputTarget.value
      card.classList.toggle("ring-2", chosen)
      card.classList.toggle("ring-primary", chosen)
      card.setAttribute("aria-pressed", String(chosen))
    })
  }
}
